<template>
  <div class="summary">
    <div class="summary__title" :class="titleClasses">
      {{ dysfunctionSummaryTitle }}
    </div>

    <div class="summary__dots color-dots">
      <div
        v-for="{ dysfunctionName } in dysfunctions"
        :key="dysfunctionName"
        class="color-dots__dot"
        :style="getColorDotStyles(dysfunctionName)"
      ></div>
    </div>

    <ul class="summary__text summary-text u-typography-helvetica u-text u-text--m">
      <li class="summary-text__point">
        {{ $t('section.yourSkin.scoringDevelopedText') }}
      </li>
      <li class="summary-text__point">
        {{ $t('section.yourSkin.crossChecksText') }}
      </li>
    </ul>
  </div>
</template>

<script>
import kebabCase from 'lodash.kebabcase';
import { mapState } from 'vuex';

import { LOCALE } from '@/constants/locale';
import { types } from '@/store/types';

export default {
  name: 'SummarySlide',
  props: {
    dysfunctions: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState({
      locale: types.state.LOCALE
    }),
    dysfunctionsNumber() {
      return this.dysfunctions.length;
    },
    dysfunctionSummaryTitle() {
      return this.dysfunctionsNumber === 1 || this.locale === LOCALE.AR
        ? this.$t('section.yourSkin.yourMainDysfunctionTitle')
        : this.$t('section.yourSkin.yourMainDysfunctionsTitle', [this.dysfunctionsNumber]);
    },
    titleClasses() {
      if (this.$windowWidth.value < 1920) {
        return ['u-typography-helvetica', 'u-text-display', 'u-text-display--s'];
      }

      return ['u-typography-helvetica', 'u-text-display', 'u-text-display--m'];
    }
  },
  methods: {
    getColorDotStyles(dysfunctionName) {
      return { backgroundColor: `var(--u-color-${kebabCase(dysfunctionName)})` };
    }
  }
};
</script>

<style lang="scss" scoped>
.summary {
  &__title {
    margin-bottom: 24px;
  }

  &__dots {
    margin-bottom: 24px;
  }
}

.color-dots {
  display: flex;

  &__dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
  }

  &__dot:not(:last-child) {
    margin-inline-end: 8px;
  }
}

.summary-text {
  list-style-position: inside;
  padding-inline-start: 8px;

  &__point:not(:last-child) {
    margin-bottom: 16px;
  }
}

@media (min-width: 960px) {
  .summary {
    &__title {
      margin-bottom: 32px;
    }

    &__dots {
      margin-bottom: 32px;
    }
  }

  .summary-text {
    &__point:not(:last-child) {
      margin-bottom: 24px;
    }
  }
}
</style>
